export default {
  "h1-title": "交易工具",
  imgUrlLang: "",
  "public-btn-text": "即刻體驗",
  screen0: {
    title: "創建滿足您交易需求的工具庫",
  },
  screen1: {
    title: "同圖商品疊加工具",
    desc: "該工具可以讓投資者清晰地了解到兩種商品任意週期任意K線的相對強弱，此外還可識別突破的有效性",
  },
  screen2: {
    title: "MACD專業指標(雙線)",
    desc: "這是一款股票和期貨常用的MACD指標工具，與MT4自帶的MACD相比，更加符合中國用戶的看盤習慣",
  },
  screen3: {
    title: "MTDriver盈虧統計指標",
    desc: "該工具可以幫助投資者精確地定位不同周期的盈虧",
  },
  screen4: {
    title: "價格變動手機推送通知",
    desc: "大部分投資者的盯盤時間較為有限,價格變動手機推送可以幫助他們在規避部分市場噪音的情況下把握市場的動向",
  },
  screen5: {
    title: "一鍵平倉EA",
    desc: "操作界面位於圖表界面中，方便投資者在極端行情發生的時候更迅速便捷地進行止損",
  },
  screen6: {
    title: "定時下單EA",
    desc: "放在MQL4Experts文件夾下，一款指定時間下單的EA，用法很簡單，用戶請自行摸索",
  },
  screen7: {
    title: "淨值監控EA",
    desc: "放在MQL4Experts文件夾下，監控淨值變動的EA，把想要提示的聲音文件放在Sounds下，然後在EA的音樂名稱填對應音樂文件的名字",
  },
  EA交易与指标: "EA交易與指標",
  EBC独家精选的MT4:
    "EBC 獨家精選的MT4/MT5指標與EA工具，協助您提升決策精準度與營運效率，優化策略，掌握市場，取得競爭優勢。",
  EBCTurbo账户分析系统:
    "EBC Turbo帳戶分析系統，深度解析交易表現，優化投資策略。",
  实用型技术指标集: "實用型技術指標集，掌握市場脈動，掌握最佳交易時機。",
  外汇EA策略执行器: "外匯EA策略執行器，高效應對市場變化，確保決策始終領先。",
  EBCTurbo账户分析系统2: "EBC Turbo帳戶分析系統",
  EBC独家盈亏统计和历史回溯工具:
    "EBC獨家盈虧統計與歷史回溯工具，基於多維度評估系統與深度嵌入模型，全面解析交易細節，協助優化交易策略",
  净值收益曲线: "淨值收益曲線",
  收益率: "收益率",
  最大回撤: "最大回撤",
  标准差: "標準差",
  获利系数: "獲利係數",
  夏普比率: "夏普比率",
  盈利交易: "獲利交易（勝率）",
  六维评级图: "六維評級圖",
  每日: "每日/月度統計",
  获取EBCTurbo: "取得EBC Turbo",
  实用型技术指标集2: "實用型技術指標集",
  经过优化的常用技术指标:
    "經過最佳化的常用技術指標，支援多角度市場分析與自訂配置，幫助使用者精確判斷市場動向。",
  同图商品叠加工具: "同圖商品疊加工具",
  帮助投资者通过叠加两个商品的走势:
    "幫助投資人透過疊加兩個商品的走勢，分析它們之間的低阻力線強弱，辨識出關鍵的突破點，提升決策準確性。",
  MACD专业指标: "MACD專業指標(雙線)",
  提供比普通MACD更为精准的双线指标:
    "提供比一般MACD更為精準的雙線指標，幫助投資人更能辨識市場的買賣訊號，進而捕捉更佳的獲利機會。",
  MTDriver盈亏统计指标: "MTDriver盈虧統計指標",
  该指标可协助投资者实时统计不同周期内的盈亏情况:
    "此指標可協助投資人即時統計不同周期內的損益情況，為制定更精準的交易策略提供數據支援。",
  价格变动手机推送通知: "價格變動手機推播通知",
  实时监控市场价格波动:
    "即時監控市場價格波動，當出現重大變動時，立即向投資者的手機發送推播通知，確保他們能夠在關鍵時刻做出迅速反應。",
  获取指标: "獲取指標",
  外汇EA策略执行器2: "外匯EA策略執行器",
  基于高级算法自动执行EA交易策略:
    "基於高級演算法自動執行EA交易策略，即時監控市場並動態調整，確保高效、安全的交易執行。",
  定时下单EA软件: "定時下單EA軟體",
  通过MT4EA:
    "透過MT4 EA / MT5 EA預設時間自動執行訂單，無需人工干預，適合在特定時間點進行交易的策略，確保交易的及時性與準確性。",
  EA交易常见问题: "EA交易常見問題",
  qaList: [
    {
      q: "1、EA交易是什麼？如何運作？",
      a: [
        "EA交易是指利用智能交易系統在MT4或MT5平台上自動執行交易操作的一種方式。能夠根據設定的策略自動買入、賣出、止損止盈，實現無需人工干預的自動化交易，幫助交易者提高執行效率、節省盯盤時間，並減少情緒干擾。",
      ],
    },
    {
      q: "2、不同交易平台的EA軟體有什麼區別？",
      a: [
        "MT4 EA只能運行在MetaTrader 4平台，使用MQL4語言編寫；MT5 EA則基於MetaTrader 5平台，採用MQL5語言，支援更多功能和多執行緒回測。選擇哪種平台取決於交易需求和EA軟體的相容性，兩者互不相容。",
      ],
    },
    {
      q: "3、可以在同一平台上運行多個EA軟體嗎？",
      a: [
        "可以在同一MetaTrader平台上運行多個EA軟體，但需要將每個智能交易系統分別載入到不同的圖表中。每個圖表中只能運行一個智能交易系統，注意避免它們之間的訂單衝突或資源佔用問題。",
      ],
    },
    {
      q: "4、外匯EA是否可以同時交易多個貨幣對？",
      a: [
        "可以，但取決於外匯EA的編寫方式。部分智能交易系統僅支援單一貨幣對，而更強大的智能交易系統可以支援多品種交易。特別是基於MT5 EA的系統，因平台本身支援多執行緒，處理多品種能力更強。",
      ],
    },
    {
      q: "5、如何選擇適合自己的外匯EA？",
      a: [
        "選擇外匯EA時應結合自己的交易風格（如趨勢跟隨或剝頭皮）、資金承受能力和風險偏好。查看智能交易系統的歷史回測、實盤表現、是否適用於MT4或MT5平台，並先在模擬帳戶中測試其穩定性和盈利能力。",
      ],
    },
    {
      q: "6、EA交易能保證盈利嗎？",
      a: [
        "EA交易的盈利能力取決於其策略邏輯、市場環境以及風控設置。無論是MT4 EA還是MT5 EA，都無法保證長期穩定盈利。市場波動不確定，智能交易系統僅是工具，投資者仍需監控和調整策略。",
      ],
    },
  ],
  url: "https://ebcturbo.com/tools?language=tw",
};
